
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","version":"1.1","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clippath"}},[_c('path',{attrs:{"stroke-width":"0","fill":"none","d":"M0 0h16v16H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#clippath)"}},[_c('path',{staticClass:"cls-3",attrs:{"d":"M13.5 11.1h-3c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h2.4V3.1H6.1v2.4c0 .3-.3.6-.6.6s-.6-.3-.6-.6v-3c0-.3.3-.6.6-.6h8c.3 0 .6.3.6.6v8c0 .3-.3.6-.6.6z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M10.5 14.1h-8c-.3 0-.6-.3-.6-.6v-8c0-.3.3-.6.6-.6h8c.3 0 .6.3.6.6v8c0 .3-.3.6-.6.6zm-7.4-1.2h6.8V6.2H3.1v6.7z"}})])])
          )
        }
      }
    